import React from 'react';
import PropTypes from 'prop-types';
import { MessageStyled } from './styles';

const Message = ({ type, style, children, withCursor, onClick, ...rest }) => {
  return (
    <MessageStyled type={type} style={style} {...rest} withCursor={!!withCursor || !!onClick}>
      {children}
    </MessageStyled>
  );
};

Message.propTypes = {
  type: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
  withCursor: PropTypes.bool,
  onClick: PropTypes.func,
};

Message.defaultProps = {
  type: 'alert',
};

export const MessageAlert = props => <Message {...props} type="alert" />;
export const MessageSuccess = props => <Message {...props} type="success" />;
export const MessageHelp = props => <Message {...props} type="help" />;

export default Message;
